const layout = {
  larguraBarraLateral: '210px'
};

export default layout;
